import { Component, OnInit, Input } from '@angular/core';
import { StudentProfileInfo } from '../../models/student-profile-info';
import { PrifactRoute } from '../../../../../models/prifact-route';
import { RoutingService } from '../../../../../services/routing-service/routing.service';
import { UserService } from 'src/app/services/user/user-service/user.service';
import { PersonType } from 'src/app/models/person';
import { FileService } from 'src/app/services/file-service/file.service';
import { StudentProfileService } from '../../services/student-profile.service';
import { Device } from '@ionic-native/device/ngx';
import { flatMap } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { ComponentBase } from 'src/app/base-classes/componet-base';
import { SettingsService } from 'src/app/services/settings/settings.service';

@Component({
  selector: 'app-student-profile',
  templateUrl: './student-profile.component.html',
  styleUrls: ['./student-profile.component.scss']
})
export class StudentProfileComponent extends ComponentBase {

  @Input() studentProfileInfo: StudentProfileInfo
  option: number = 11;
  personType: PersonType;
  showStudentFileSelector: boolean;
  selectedFile: File;
  showStudentImage: boolean = true;
  student_force_reload: boolean = false;
  errorMessage: string = null;
  isOnlinePaymentEnabled: boolean = false;

  constructor(private routingService: RoutingService
    , private userService: UserService
    , public device: Device
    , private fileService: FileService
    , private activatedRoute: ActivatedRoute
    , private studentProfileService: StudentProfileService
    , private settingsService: SettingsService) {
    super();
  }

  ngOnInit() {
    let sub1 = this.userService.getLoggedInUser().subscribe(user => {
      this.personType = user.person.person_type;
    });
    this.addSubscription(sub1);
    let sub2 = this.activatedRoute.queryParams.subscribe((params) => {
      if (params['suboption']) {
        this.option = +params['suboption'];
      };
    });
    this.addSubscription(sub2);
    let sub3 = this.settingsService.getSettings()
      .subscribe(res => {
        this.isOnlinePaymentEnabled = res.is_online_payment_enabled;
      });
    this.addSubscription(sub3)
  }

  onProfileEdit() {
    let route = new PrifactRoute();
    route.primary_command = ['pages', 'student-account-edit'];
    route.append_current_url_to_history = true;
    this.routingService.navigate(route);
  }

  onChangeStudentPhoto() {
    this.showStudentFileSelector = true;
  }

  onStudentFileSelect(files: Array<File>) {
    this.showStudentImage = false;
    this.showStudentFileSelector = false;
    this.selectedFile = files[0];
    this.fileService.uploadFile(this.selectedFile).pipe(
      flatMap(res => {
        if (res.message) {
          this.errorMessage = res.message;
          setTimeout(() => {
            this.errorMessage = null;
          }, 3000);
        }
        else {
          return this.studentProfileService.updateProfilePhoto(this.studentProfileInfo.student_info.person_id, 1, res);
        }
      })
    )
      .subscribe(res => {
        this.student_force_reload = true;
        this.showStudentImage = true;
      });
  }

}
